// extracted by mini-css-extract-plugin
export default {"container":"Cg9C"};